<div class="kkb-board">
  <div class="kkb-column" *ngFor="let column of columns">
    <div class="kkb-column-header" [ngClass]="'kkb-header--' + column.category.toLowerCase()">
      <span class="kkb-column-title">{{ column.category }}</span>
      <span class="kkb-column-count">{{ column.customers.length }}</span>
    </div>
    <div
      class="kkb-column-body"
      cdkDropList
      [id]="dropListId(column.category)"
      [cdkDropListData]="column.customers"
      [cdkDropListConnectedTo]="connectedDropListIds"
      (cdkDropListDropped)="drop($event, column.category)"
    >
      <div
        class="kkb-card"
        *ngFor="let c of column.customers"
        cdkDrag
        (click)="cardClick(c)"
      >
        <div class="kkb-card-name">{{ c.name || 'No name' }}</div>
        <div class="kkb-card-sub" *ngIf="c.orgId">Org. {{ c.orgId }}</div>
        <div class="kkb-card-sub" *ngIf="c.email">{{ c.email }}</div>
        <div class="kkb-card-sub" *ngIf="c.ownerName">Owner: {{ c.ownerName }}</div>
        <div class="kkb-card-sub" *ngIf="c._systems?.length">{{ c._systems.length }} system{{ c._systems.length > 1 ? 's' : '' }}<span *ngIf="c._groupCount"> · {{ c._groupCount }} group{{ c._groupCount > 1 ? 's' : '' }}</span></div>
        <div class="kkb-card-type" *ngIf="c.customerType">{{ c.customerType }}</div>
      </div>
      <div class="kkb-empty" *ngIf="!column.customers.length">No customers</div>
    </div>
  </div>
</div>
